/* @ngInject */
function tagsService (ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    createTag,
    getTags,
    updateTag,
    deleteTag
  }
  return service

  function createTag (name) {
    return ConnectorWebService.post(CONSTANTS.URL_TAGS, name)
  }

  function updateTag (id, name) {
    return ConnectorWebService.put(Utils.fnReplaceStringParams(CONSTANTS.URL_TAGS_ID, [id]), name)
  }

  function deleteTag (id) {
    return ConnectorWebService.fnDelete(Utils.fnReplaceStringParams(CONSTANTS.URL_TAGS_ID, [id]))
  }

  function getTags (queryParams) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TAGS_ALL)

    if (queryParams) {
      const { name, sort, order, top, skip, tagsIds } = queryParams

      if (name) url = Utils.fnAddQueryToUrl(url, { name })
      if (sort) url = Utils.fnAddQueryToUrl(url, { $sort: sort })
      if (order) url = Utils.fnAddQueryToUrl(url, { $order: order })
      if (top) url = Utils.fnAddQueryToUrl(url, { $top: top })
      if (skip) url = Utils.fnAddQueryToUrl(url, { $skip: skip })

      if (tagsIds?.length) {
        tagsIds.forEach(tagId => {
          url = Utils.fnAddQueryToUrl(url, { tagsIds: tagId })
        })
      }
    }

    return ConnectorWebService.get(url)
  }
}

export { tagsService }
